/**
 * 공개 설정값. 클라이언트 ID는 비밀이 아니다 (브라우저 앱에 공개되는 값).
 * 클라이언트 secret·토큰·passphrase는 절대 코드에 넣지 않는다.
 */
export const GOOGLE_CLIENT_ID = '633196798870-hja5dm7dtublojlko01tj8eh04fmc0jv.apps.googleusercontent.com';

/** Drive의 앱 전용 숨김 공간만 접근 (사용자의 일반 Drive 파일에는 접근 불가) */
export const DRIVE_SCOPE = 'https://www.googleapis.com/auth/drive.appdata';
